<template>
  <div>
    <v-layout row justify-end class="mt-2">
      <v-flex xs12>
        <InputSearch class="mb-3" :search="filter" @clickSearch="onSearch" :placeholder="'ค้นหา'" />
      </v-flex>
    </v-layout>

    <v-flex xs12>
      <div style="display: flex; align-items: center">
        <v-flex>
          <Typography h2 bold :label="$t('Techhunt Type')" />
        </v-flex>
        <v-btn
          variant="outlined"
          icon
          :color="'#BECCDB'"
          style="border-radius: 50% !important"
          @click="addType = true"
        >
          <img :src="`/static/img/Add.png`" alt class="responsive-img" style="height: 14px" />
        </v-btn>
      </div>
    </v-flex>

    <!-- <v-layout row wrap dense class="ma-0">
      <v-flex xs6>
        <div class="headline primary--text">{{ $t('Techhunt Type') }}</div>
      </v-flex>
      <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
        <div class="text-xs-right form-control" style="display: flex; align-items: center">
          <div class="text-xs-center">
            <v-btn
              @click="addType = true"
              color="#152d53"
              small
              outline
              style="color: #152d53; text-transform: capitalize"
              class="px-4"
              ><i class="fas fa-plus mr-2"></i> Add type</v-btn
            >
          </div>
        </div>
      </v-flex>
    </v-layout> -->
    <!-- <div style="display: flex; justify-content: flex-end">
      <div class="depainput form-control mb-3" style="position: relative; width: 40%">
        <input
          v-model="searchText"
          @keyup="searchByText(searchText)"
          style="padding-right: 47px !important"
          type="text"
        />
        <v-btn
          @click="searchByText(searchText)"
          :loading="loading"
          style="position: absolute; right: 0px; top: 0px"
          icon
          ><v-icon color="primary">search</v-icon></v-btn
        >
      </div>
    </div> -->
    <v-layout class="my-5" justify-center v-if="loading">
      <v-progress-circular
        :size="100"
        :width="10"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-layout>
    <div v-else>
      <v-data-table
        :headers="headers"
        :items="showData"
        hide-actions
        select-all
        item-key="name"
        :pagination.sync="pagination"
        class="fixTable"
      >
        <template v-slot:headers="props">
          <tr style="background-color: #152d53; color: white">
            <th
              style="background-color: #152d53; color: yellow; text-align: left"
              v-for="(header, k) in props.headers"
              :key="header.text + k"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr class="py-3 depatable">
            <td class="text-xs-left" style="width: 70px">
              <Typography left h5 :label="props.item.typeid || '-'" />
            </td>
            <td class="text-xs-left">
              <Typography left h5 :label="props.item.typename || '-'" />
            </td>
            <td class="text-xs-center" style="width: 70px">
              <!-- <v-btn @click="clickUpdate(props.item)" icon outline>
                <i :color="$vuetify.theme.primary" class="fas fa-pencil-alt"></i>
              </v-btn>
              <v-btn @click="clickDelete(props.item.typeid)" icon outline>
                <v-icon color="primary">delete</v-icon>
              </v-btn> -->
              <TooltipTable
                :datas="props"
                @modalEdit="clickUpdate(props.item)"
                @Delete="deleteType(props.item.typeid)"
                showDelete
              ></TooltipTable>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <!-- <v-dialog persistent v-model="popDelete" max-width="500">
      <v-card class="p-3">
        <v-card-title class="text-h5 grey lighten-2">
          <h6>ต้องการจะลบใช่หรือไม่</h6>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteType"> ใช่ </v-btn>
          <v-btn color="danger" text @click="popDelete = false"> ยกเลิก </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog v-if="addType" persistent v-model="addType" max-width="500">
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="addType = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-layout class="mx-3 pb-3" column>
          <Typography class="mb-2" h2 bold label="เพิ่มประเภทธุรกิจ" />
          <Typography h5 semiBold label="ประเภทธุรกิจ*" />
          <div class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('Type name') }">
            <input
              type="text"
              name="Type name"
              v-model="createType.name"
              placeholder="Type name"
              maxlength="255"
              v-validate="'required'"
            />
            <p class="text-error" v-if="errors.has('Type name')">{{ errors.first('Type name') }}</p>
          </div>
          <Typography h5 semiBold label="ประเภท" />
          <v-radio-group color="primary" v-model="createType.type" row class="text-xs">
            <v-radio color="primary" :label="$t('บัญชีบริการดิจิทัล')" :value="1"></v-radio>
            <v-radio color="primary" :label="$t('Digital skill')" :value="2"></v-radio>
          </v-radio-group>
          <!-- <div v-if="error" style="color:red;">กรุณากรอกข้อมูลให้ครบ</div> -->
          <!-- <v-layout row justify-center>
            <v-btn
              @click="saveType"
              color="#152d53"
              outline
              style="color: #152d53; text-transform: capitalize"
              class="px-4"
              >ตกลง</v-btn
            >
          </v-layout> -->
          <div style="display: flex; justify-content: center" class="mt-3">
            <Button :loading="loading" outline :label="$t('cancel')" @click="addType = false" />
            <Button :loading="loading" depressed :label="$t('Save')" @click="saveType" />
          </div>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-if="updateType" persistent v-model="updateType" max-width="500">
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="updateType = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-layout class="mx-3 pb-3" column>
          <Typography class="mb-2" h2 bold label="แก้ไขประเภทธุรกิจ" />
          <Typography h5 semiBold label="ประเภทธุรกิจ*" />
          <div class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('Type name') }">
            <input
              type="text"
              name="Type name"
              v-model="updateTypeData.typename"
              placeholder="Type name"
              maxlength="255"
              v-validate="'required'"
            />
            <p class="text-error" v-if="errors.has('Type name')">{{ errors.first('Type name') }}</p>
          </div>
          <Typography h5 semiBold label="ประเภท" />
          <v-radio-group color="primary" v-model="updateTypeData.type" row class="text-xs">
            <v-radio color="primary" :label="$t('บัญชีบริการดิจิทัล')" :value="1"></v-radio>
            <v-radio color="primary" :label="$t('Digital skill')" :value="2"></v-radio>
          </v-radio-group>
          <!-- <div v-if="error" style="color:red;">กรุณากรอกข้อมูลให้ครบ</div> -->
          <!-- <v-layout row justify-center>
            <v-btn
              @click="fetchupdatetype"
              color="#152d53"
              outline
              style="color: #152d53; text-transform: capitalize"
              class="px-4"
              >ตกลง</v-btn
            >
          </v-layout> -->
          <div style="display: flex; justify-content: center" class="mt-3">
            <Button :loading="loading" outline :label="$t('cancel')" @click="updateType = false" />
            <Button :loading="loading" depressed :label="$t('Save')" @click="fetchupdatetype" />
          </div>
        </v-layout>
      </v-card>
    </v-dialog>
    <Paginations
      @clickPagination="changepage"
      @sortPage="sortPage"
      :pageCount="pageCount"
      :numberPage="numberPage"
      :page="page"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import api from '@/api'
import InputSearch from '@/components/elements/InputSearch.vue'
import Typography from '@/components/elements/Typography.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Button from '@/components/elements/Button.vue'
import Paginations from '@/components/elements/Paginations.vue'

export default {
  components: {
    Multiselect,
    InputSearch,
    Typography,
    TooltipTable,
    Button,
    Paginations
  },
  data() {
    return {
      filter: {
        nameAll: ''
      },
      loading: false,
      // popDelete: false,
      // prepareDelete: null,
      searchText: '',
      addType: false,
      updateType: false,
      pagination: {
        descending: false,
        sortBy: 'name',
        rowsPerPage: 999
      },
      createType: {
        name: '',
        type: ''
      },
      headers: [
        { text: 'ID', align: 'center', value: 'id' },
        { text: this.$t('Techhunt Type'), align: 'center', value: 'type' },
        { text: '', align: 'center', value: 'delete' }
      ],
      updateTypeData: {
        typename: '',
        typeid: null,
        type: '',
      },
      data: [],
      showData: [],
      error: false,
      page: 1,
      pageTotal: 0,
      rowsPerPage: 12,
      numberPage: {
        page: undefined
      }
    }
  },
  computed: {
    pageCount() {
      if (this.pageTotal !== 0) {
        let count = Math.ceil(this.pageTotal / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    }
  },
  mounted() {
    this.setupData()
  },
  methods: {
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.getType()
      this.loading = false
    },
    async sortPage(pages) {
      let count = Math.ceil(this.pageTotal / this.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      if (pages) {
        this.page = parseInt(pages)
        this.loading = true
        await this.getType()
        this.loading = false
      }
    },
    async onSearch() {
      this.loading = true
      this.page = parseInt(1)
      await this.getType()
      this.loading = false
    },
    setupData() {
      this.getType()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    clickUpdate(data) {
      this.updateTypeData.typename = data.typename
      this.updateTypeData.typeid = data.typeid
      this.updateTypeData.type = data.type
      this.updateType = true
    },
    async deleteType(id) {
      this.$swal
        .fire({
          type: 'question',
          text: 'ยืนยันการลบ?',
          showCancelButton: true
        })
        .then(async result => {
          if (result.value) {
            let res = await api.deleteType(id)
            if (res == 204) {
              this.getType()
              // this.popDelete = false
            }
          }
        })
    },
    async saveType() {
      // console.log('saveType :',this.createType.name , this.createType.type);
      var isValid = await this.$validator.validate()
      if (isValid && this.createType.name) {
        let obj = {
          typename: this.createType.name,
          type: this.createType.type
        }
        let res = await api.createType(obj)
        if (res == 204) {
          this.createType.name = ''
          this.createType.type = ''
          this.addType = false
          this.error = false
          this.$swal.fire({
            type: 'success',
            title: '<div class="headline primary--text bold7 fs-24">บันทึกข้อมูลสำเร็จ</div>',
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
          })
          this.getType()
        }
      } else {
        this.error = true
      }
    },
    async fetchupdatetype() {
      if (this.updateTypeData.typename && this.updateTypeData.typeid) {
        let obj = {
          typename: this.updateTypeData.typename,
          type: this.updateTypeData.type,
        }
        let res = await api.updateType(this.updateTypeData.typeid, obj)
        if (res == 204) {
          this.updateTypeData = {
            typename: '',
            typeid: null
          }
          this.updateType = false
          this.error = false
          this.$swal.fire({
            type: 'success',
            title: '<div class="headline primary--text bold7 fs-24">แก้ไขข้อมูลสำเร็จ</div>',
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
          })
          this.getType()
        }
      } else {
        this.error = true
      }
    },
    async getType() {
      this.loading = true
      try {
        var params = {
          nameAll: this.filter.nameAll ? this.filter.nameAll : null,
          limit: this.limitCom,
          offset: this.offsetCom
        }
        this.data = await api.getType(params)
        this.loading = false
        this.showData = this.data.data
        this.pageTotal = this.data.total ? this.data.total : []
      } catch (error) {
        console.error(error)
      }
    },
    searchByText(text) {
      if (text == '') {
        this.showData = this.data
        return
      }
      let output = []
      this.data.forEach(ele => {
        if (ele.typename.toLowerCase().match(text.toLowerCase())) {
          output.push(ele)
        }
      })
      this.showData = output
    },
    searchType(arr, text) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].typename == text) {
          return arr[i].typeid
        }
      }
    },
    selectTypeByid(id) {
      for (let i = 0; i < this.type.length; i++) {
        if (this.type[i].typeid == id) {
          return this.type[i].typename
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
  tbody {
    tr {
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      td:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/techhuntMaster/Type.vue